module.exports = __webpack_public_path__ + "assets/import.47458db1.svg";